import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { LANGUAGES } from '../utils/i18n';
import { routeKeyFromPath, routePath } from '../i18n/routes';
import { ChevronDown, Globe } from 'lucide-react';

const LanguageSwitcher = () => {
  const { currentLanguage, switchLanguage } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const currentLang = LANGUAGES.find(lang => lang.code === currentLanguage);

  const handleLanguageChange = (languageCode) => {
    const match = routeKeyFromPath(location.pathname);
    if (match) {
      navigate(`${routePath(match.key, languageCode)}${location.search}${location.hash}`);
    } else {
      switchLanguage(languageCode);
    }
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <button
        data-testid="language-switcher-toggle"
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-2 px-3 py-2 rounded-lg hover:bg-gray-100 transition-colors duration-200"
      >
        <Globe className="w-4 h-4 text-gray-600" />
        <span className="text-sm font-medium text-gray-700">{currentLang?.flag}</span>
        <span className="text-sm font-medium text-gray-700 hidden sm:block">{currentLang?.name}</span>
        <ChevronDown className={`w-4 h-4 text-gray-600 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {isOpen && (
        <div
          data-testid="language-switcher-menu"
          className="absolute top-full right-0 mt-2 bg-white rounded-lg shadow-lg border border-gray-200 py-2 min-w-[170px] z-50"
        >
          {LANGUAGES.map((language) => (
            <button
              key={language.code}
              data-testid={`language-option-${language.code}`}
              onClick={() => handleLanguageChange(language.code)}
              className={`w-full flex items-center space-x-3 px-4 py-2 text-left hover:bg-gray-50 transition-colors duration-200 ${
                currentLanguage === language.code ? 'bg-blue-50 text-blue-600' : 'text-gray-700'
              }`}
            >
              <span className="text-lg">{language.flag}</span>
              <span className="font-medium">{language.name}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
